module.exports = __webpack_public_path__ + "static/media/Hospitality_20.2b70c1be.jpg";